import { z } from 'zod';

export const forgotPasswordSchema = z.object({
    email: z.string().min(1, 'Email is required').email('Enter a valid email address'),
});

export type ForgotPasswordFormInputs = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
    .object({
        password: z.string().min(8, 'Password must be at least 8 characters'),
        password_confirmation: z.string().min(1, 'Please confirm your password'),
    })
    .refine((data) => data.password === data.password_confirmation, {
        message: 'Passwords do not match',
        path: ['password_confirmation'],
    });

export type ResetPasswordFormInputs = z.infer<typeof resetPasswordSchema>;
